import { IconFn, IconSvg } from "../createIcon";

export const ErrorOutlineIcon: IconFn = ({ color = "#F56B55", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 42, height: 40 }} {...props}>
    <g clipPath="url(#clip0_1613_12663)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7919 1.95812C19.7319 0.18843 22.2676 0.188447 23.2076 1.95812L41.4627 36.3264C42.3472 37.9915 41.1403 39.9991 39.2549 39.9991H2.74465C0.85921 39.9991 -0.34767 37.9915 0.53678 36.3264L18.7919 1.95812ZM20.9998 4.19674L3.57639 36.9991H38.4231L20.9998 4.19674Z"
        fill={color}
      />
      <path d="M18.9293 14.748H23.0827V25.1699H18.9293V14.748Z" fill={color} />
      <path d="M18.9219 29.3379H23.0835V33.5H18.9219V29.3379Z" fill={color} />
    </g>
    <defs>
      <clipPath id="clip0_1613_12663">
        <rect width={42} height={40} fill="white" />
      </clipPath>
    </defs>
  </IconSvg>
);
